import {main_phaser} from "../framework/src/engine/madnes/MadnesApp";
import {
	madnes_get_json,
	madnes_set_hand_cursor,
	madnes_set_input_down, madnes_set_input_up,
	madnes_set_win_factors
} from "../framework/src/engine/madnes/madnes";
import {
	he, multi,
	picture_convert,
	reels_lenghts,
	reels_pos,
	server_config,
	wi,
	behavior_config
} from "../framework/src/engine/madnes/madnes_variables";
import {
	madnes_add_graphics,
	madnes_graphics_begin_fill,
	madnes_graphics_draw_rectangle
} from "../framework/src/engine/madnes/madnes_draw";
import {madnes_audio_allow_multiple, madnes_audio_loop} from "../framework/src/engine/madnes/madnes_audio";
import {j27_infomenu_init} from "./j27_infomenu";
import {
	madnes_loader_add_audio, madnes_loader_add_json_atlas,
	madnes_loader_create, madnes_loader_set_oncomplete,
	madnes_loader_start
} from "../framework/src/engine/madnes/madnes_loader";
import {
	madnes_add_child,
	madnes_add_group,
	madnes_add_img,
	madnes_add_sprite,
	madnes_add_to_group,
	madnes_set_alpha,
	madnes_set_angle, madnes_set_cstm_val,
	madnes_set_img_center,
	madnes_set_pos, madnes_set_scale,
	madnes_set_visible,
	madnes_sprite_set_frame_name
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_add_bitmap_text, madnes_add_text, madnes_set_text_shadow} from "../framework/src/engine/madnes/madnes_text";
import {cylinder_pos} from "./j27_config";
import {stopposin, stopposin_old} from "./j27_core";
import {hide_all_lines, hide_all_win_dots} from "./j27_core_res_ctrl";
import {set_show_money_pos_x} from "../framework/src/engine/madnes/madnes_anims";

// Vytvoreni potrebnych onjektu z nactenych textur.
export function j27_print_desk()
{
	if(typeof behavior_config.reel.spin.motionBlur == "undefined")
	{
		behavior_config.reel.spin.motionBlur = 1;
	}

	if(typeof behavior_config.reel.spin.timeToReachFullSpeed == "undefined")
	{
		behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
		if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
		{
			behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
		}
	}

	if(typeof behavior_config.reel.spin.timeToReachNullSpeed == "undefined")
	{
		behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
		if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
		{
			behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
		}
	}

	if(typeof behavior_config.reel.acceleration.moveTime != "undefined")
	{
		behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.moveTime;
	}

	if(typeof behavior_config.reel.brake.moveTime != "undefined")
	{
		behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.brake.moveTime;
	}

	if(behavior_config.reel.spin.timeToReachFullSpeed == 0)
	{
		behavior_config.reel.spin.timeToReachFullSpeed = 0.01;
	}

	if(behavior_config.reel.spin.timeToReachNullSpeed == 0)
	{
		behavior_config.reel.spin.timeToReachNullSpeed = 0.01;
	}

	if(behavior_config.reel.spin.timeToReachFullSpeed > 0.5)
	{
		behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
	}

	if(behavior_config.reel.spin.timeToReachNullSpeed > 0.5)
	{
		behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
	}

	madnes_set_win_factors(
		behavior_config.reel.minBigWinFactor,
		behavior_config.reel.minMegaWinFactor,
		behavior_config.reel.minSuperMegaWinFactor
	);

//	if(
//		typeof server_config.logic != "undefined" &&
//		typeof server_config.logic.bet_set != "undefined"
//	)
//	{
//		/*console.log(server_config.logic.bet_set);
//
//		madnes_init_bets(server_config.logic.bet_set);
//		///bets = server_config.logic.bet_set;
//		console.log(bets);*/
//	}

	// bets = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

	madnes_add_img("bckground", "background", 0, 0);
	madnes_set_scale("bckground", 1.05, 1);
	//madnes_add_img("freespin_bg", "freespin_bg", 58, 30, 0);

	madnes_add_img("bonus_reels", "bonus_reels", 0, 0);
	madnes_set_visible("bonus_reels", false);
	madnes_set_scale("bonus_reels", 1.05, 1);

	// Nastaveni / vytvoreni pasu pro valce podle navratu ze serveru
	for(var i = 0; i < cylinder_pos.length; i++)
	{

		for(var j in server_config.logic.reels[i])
		{
			madnes_add_sprite("reels_bufer_"+i+"_"+j, "symbols_blur_atlas", cylinder_pos[i], -9999);
			madnes_sprite_set_frame_name("reels_bufer_"+i+"_"+j, picture_convert[server_config.logic.reels[i][j]]);
			//madnes_sprite_set_frame("reels_bufer_"+i+"_"+j, 1);
			madnes_set_img_center("reels_bufer_"+i+"_"+j, 0.5, 0.5);

			reels_lenghts[i] = j * 1 + 1;
			stopposin[i] = reels_lenghts[i];
			stopposin_old[i] = reels_lenghts[i];
		}

		// S0-S2 = priprava vyherni pozice na kazdem valci
		madnes_add_sprite("reels_bufer_"+i+"_S0", "symbols_atlas", cylinder_pos[i], -9999);
		madnes_sprite_set_frame_name("reels_bufer_"+i+"_S0", picture_convert[server_config.matrix.reelMatrix[i][2]]);
		madnes_set_img_center("reels_bufer_"+i+"_S0", 0.5, 0.5);

		madnes_add_sprite("reels_bufer_"+i+"_S1", "symbols_atlas", cylinder_pos[i], -9999);
		madnes_sprite_set_frame_name("reels_bufer_"+i+"_S1", picture_convert[server_config.matrix.reelMatrix[i][2]]);
		madnes_set_img_center("reels_bufer_"+i+"_S1", 0.5, 0.5);

		madnes_add_sprite("reels_bufer_"+i+"_S2", "symbols_atlas", cylinder_pos[i], -9999);
		madnes_sprite_set_frame_name("reels_bufer_"+i+"_S2", picture_convert[server_config.matrix.reelMatrix[i][2]]);
		madnes_set_img_center("reels_bufer_"+i+"_S2", 0.5, 0.5);

//		madnes_add_sprite("reels_bufer_" + i + "_TMP0", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
//		madnes_set_img_center("reels_bufer_" + i + "_TMP0", 0.5, 0);
//
//		madnes_add_sprite("reels_bufer_" + i + "_TMP1", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
//		madnes_set_img_center("reels_bufer_" + i + "_TMP1", 0.5, 0);
//
//		madnes_add_sprite("reels_bufer_" + i + "_TMP2", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
//		madnes_set_img_center("reels_bufer_" + i + "_TMP2", 0.5, 0);

		reels_pos[i] = 0;
	}

//	for(var icon in icons) {
//		madnes_add_sprite(icon, icon, -9999, -9999);
//	}
//
//	setTimeout(function() {
//		for(var icon in icons) {
//			madnes_remove_sprite(icon);
//		}
//	}, 100);

	madnes_add_img("bckground2", "reels_cover", 0, 0);
	madnes_set_scale("bckground2", 1.05, 1);

	var winlineX = 120;
	var winlineYTop = 226;
	var winlineYCenter = 386;
	var winlineYBottom = 546;

	madnes_add_img("winline_0", "winline_0", winlineX, winlineYTop);
	madnes_add_img("winline_1", "winline_1", winlineX, winlineYTop);
	madnes_add_img("winline_2", "winline_2", winlineX, winlineYTop);

	madnes_add_img("winline_3", "winline_3", winlineX, winlineYTop);
	madnes_add_img("winline_4", "winline_4", winlineX, winlineYTop);
	madnes_add_img("winline_5", "winline_5", winlineX, winlineYTop);

	madnes_add_img("winline_6", "winline_6", winlineX, winlineYTop);
	madnes_add_img("winline_7", "winline_7", winlineX, winlineYTop);
	madnes_add_img("winline_8", "winline_8", winlineX, winlineYTop);

	madnes_add_img("winline_9", "winline_9", winlineX, winlineYTop);
	madnes_add_img("winline_10", "winline_10", winlineX, winlineYTop);
	madnes_add_img("winline_11", "winline_11", winlineX, winlineYTop);

	madnes_add_img("winline_12", "winline_12", winlineX, winlineYTop);
	madnes_add_img("winline_13", "winline_13", winlineX, winlineYCenter);
	madnes_add_img("winline_14", "winline_14", winlineX, winlineYCenter);

	madnes_add_img("winline_15", "winline_15", winlineX, winlineYTop);
	madnes_add_img("winline_16", "winline_16", winlineX, winlineYCenter);
	madnes_add_img("winline_17", "winline_17", winlineX, winlineYCenter);

	madnes_add_img("winline_18", "winline_18", winlineX, winlineYTop);
	madnes_add_img("winline_19", "winline_19", winlineX, winlineYTop);
	madnes_add_img("winline_20", "winline_20", winlineX, winlineYTop);

	madnes_add_img("winline_21", "winline_21", winlineX, winlineYTop);
	madnes_add_img("winline_22", "winline_22", winlineX, winlineYCenter);
	madnes_add_img("winline_23", "winline_23", winlineX, winlineYCenter);

	madnes_add_img("winline_24", "winline_24", winlineX, winlineYTop);
	madnes_add_img("winline_25", "winline_25", winlineX, winlineYCenter);
	madnes_add_img("winline_26", "winline_26", winlineX, winlineYBottom);

	for (let i = 0; i < 27; i++) {
		madnes_set_scale("winline_"+i, 1.06, 1);
	}

	hide_all_lines();

	madnes_add_img("bonus_cover", "bonus_cover", 0, 0);
	madnes_set_visible("bonus_cover", false);
	madnes_set_scale("bonus_cover", 1.05, 1);

	madnes_add_img("win_dot_left_0", "win_dot", 73, 203);
	madnes_add_img("win_dot_left_1", "win_dot", 73, 363);
	madnes_add_img("win_dot_left_2", "win_dot", 73, 523);

	madnes_add_img("win_dot_right_0", "win_dot", 1130, 203);
	madnes_add_img("win_dot_right_1", "win_dot", 1130, 363);
	madnes_add_img("win_dot_right_2", "win_dot", 1130, 523);

	hide_all_win_dots();

	var shiftBigWinX = -38;
	var shiftBigWinY = 30;

	madnes_add_img('bigwin_bg', 'bigwin_bg', main_phaser.width / 2 * multi, main_phaser.height / 2 * multi, 0, 0.5, 0.5); //text_wintype
	madnes_add_img('bigwin_label', 'bigwin_label', 0, -130, 1, 0.5, 0.5);
	madnes_add_img('megawin_label', 'megawin_label', 0, -130, 1, 0.5, 0.5);
	madnes_add_img('supermegawin_label', 'supermegawin_label', 0, -130, 1, 0.5, 0.5);
	madnes_add_child('bigwin_bg', 'bigwin_label');
	madnes_add_child('bigwin_bg', 'megawin_label');
	madnes_add_child('bigwin_bg', 'supermegawin_label');

	//madnes_set_visible('bigwin_bg', false);
	//hide_all_bigwin_texts();

	madnes_add_img('bonuswin', 'bigwin_bg', main_phaser.width / 2 * multi, main_phaser.height / 2 * multi, 1, 0.5, 0.5);
	madnes_set_visible('bonuswin', false);
	madnes_add_img('bonus_label', 'bonus_label', 0, -130, 1, 0.5, 0.5);
	madnes_add_child('bonuswin', 'bonus_label');

	var bonusGamesStyle = {
		font: "30px Arial",
		fontWeight: "bold",
		//'stroke': '#000',
		//'strokeThickness': 3,
		'fill': "yellow",
	};

	madnes_add_text("text_bonus_games_num", 736, 98, "0/0", bonusGamesStyle);
	madnes_set_img_center("text_bonus_games_num", 1, 0);
	madnes_set_visible("text_bonus_games_num", false);

	madnes_add_bitmap_text('windesk_sum', 'bigwin_fonts', wi / 2, he / 2 + 80, "", 80);
	madnes_set_img_center('windesk_sum', 0.5, 0.5);
	madnes_set_visible('windesk_sum', false);

	set_show_money_pos_x(wi /2);

	// madnes_recount_bet();
}

function hide_all_bigwin_texts() {
	madnes_set_visible('bigwin_label', false);
	madnes_set_visible('megawin_label', false);
	madnes_set_visible('supermegawin_label', false);
	//madnes_set_visible('bonus_label', false);
}

export function show_bigwin_label(type) {
	hide_all_bigwin_texts();
	madnes_set_visible(type, true);
}
